
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5258',
  depVersions: {
  "data-privacy-request-ui": "static-1.5258",
  "data-fetching-client": "static-1.9410",
  "head-dlb": "static-1.4754",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7724",
  "hub-http-shared-msw-handlers": "static-1.9309",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11155",
  "I18n": "static-7.1553",
  "jasmine-runner": "static-1.6193",
  "privacy-center-public-service-types": "static-1.4521",
  "quartz": "static-1.6630",
  "react-dlb": "static-1.70",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5293",
  "UIComponents": "static-3.8102",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.80",
  "foundations-assets": "static-1.4565",
  "foundations-components": "static-1.7381",
  "foundations-components-test-utils": "static-1.4864",
  "foundations-theming": "static-1.4140",
  "hub-http": "static-1.5872",
  "quartz-config": "static-1.408",
  "quartz-core": "static-1.5849",
  "quick-fetch": "static-1.3669",
  "raven": "static-3.5624",
  "react": "static-7.176",
  "react-rhumb": "static-1.16368",
  "SharedI18nStrings": "static-1.179",
  "ui-addon-i18n": "static-1.10863",
  "usage-tracker": "static-1.7067",
  "usage-tracker-anonymous": "static-1.5484",
  "usage-tracker-core": "static-1.6917",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3873",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9346",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3167",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2907",
  "quartz-webpack": "static-1.2854",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "HeadJS": "static-2.699",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2835",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3844",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "react-utils": "static-2.5114",
  "StyleGuideUI": "static-3.482",
  "jasmine": "static-4.4064",
  "rpc-client-utils": "static-1.4346",
  "HubStyle": "static-2.11463",
  "ui-addon-draggable": "static-3.4482",
  "cssUtils": "static-1.712",
  "hs-story-utils": "static-1.9160",
  "icons": "static-2.618",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1073",
  "bend-plugin-foundations-components": "static-1.3650",
  "floating-ui": "static-1.50",
  "foundations-theming-specialty": "static-1.1856",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1026",
  "ui-fonts": "static-1.417",
  "bend-plugin-foundations-theming": "static-1.2623",
  "foundations-theming-base": "static-1.3125",
  "stylex": "static-1.26",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.781",
  "hubspotter-http": "static-1.4418",
  "mobile-manifest-mixins": "static-1.472",
  "quartz-auth": "static-1.305",
  "quartz-head": "static-1.295",
  "quartz-i18n": "static-1.305",
  "quartz-routing": "static-1.60",
  "quartz-test": "static-1.305",
  "usage-tracker-container": "static-1.7057",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2867",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.64",
  "sassPrefix": "static-1.150",
  "hubspotter-http-shared-msw-handlers": "static-1.9307"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5258",
  "data-fetching-client": "/data-fetching-client/static-1.9410",
  "head-dlb": "/head-dlb/static-1.4754",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7724",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9309",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11155",
  "I18n": "/I18n/static-7.1553",
  "jasmine-runner": "/jasmine-runner/static-1.6193",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4521",
  "quartz": "/quartz/static-1.6630",
  "react-dlb": "/react-dlb/static-1.70",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5293",
  "UIComponents": "/UIComponents/static-3.8102",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "foundations-assets": "/foundations-assets/static-1.4565",
  "foundations-components": "/foundations-components/static-1.7381",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4864",
  "foundations-theming": "/foundations-theming/static-1.4140",
  "hub-http": "/hub-http/static-1.5872",
  "quartz-config": "/quartz-config/static-1.408",
  "quartz-core": "/quartz-core/static-1.5849",
  "quick-fetch": "/quick-fetch/static-1.3669",
  "raven": "/raven/static-3.5624",
  "react": "/react/static-7.176",
  "react-rhumb": "/react-rhumb/static-1.16368",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10863",
  "usage-tracker": "/usage-tracker/static-1.7067",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5484",
  "usage-tracker-core": "/usage-tracker-core/static-1.6917",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9346",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3167",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2907",
  "quartz-webpack": "/quartz-webpack/static-1.2854",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "HeadJS": "/HeadJS/static-2.699",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2835",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3844",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "react-utils": "/react-utils/static-2.5114",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "jasmine": "/jasmine/static-4.4064",
  "rpc-client-utils": "/rpc-client-utils/static-1.4346",
  "HubStyle": "/HubStyle/static-2.11463",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4482",
  "cssUtils": "/cssUtils/static-1.712",
  "hs-story-utils": "/hs-story-utils/static-1.9160",
  "icons": "/icons/static-2.618",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1073",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3650",
  "floating-ui": "/floating-ui/static-1.50",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1856",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1026",
  "ui-fonts": "/ui-fonts/static-1.417",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2623",
  "foundations-theming-base": "/foundations-theming-base/static-1.3125",
  "stylex": "/stylex/static-1.26",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.781",
  "hubspotter-http": "/hubspotter-http/static-1.4418",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.472",
  "quartz-auth": "/quartz-auth/static-1.305",
  "quartz-head": "/quartz-head/static-1.295",
  "quartz-i18n": "/quartz-i18n/static-1.305",
  "quartz-routing": "/quartz-routing/static-1.60",
  "quartz-test": "/quartz-test/static-1.305",
  "usage-tracker-container": "/usage-tracker-container/static-1.7057",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2867",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.64",
  "sassPrefix": "/sassPrefix/static-1.150",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9307"
}
};
